// src/components/store/sections/faqs/FaqV54GlasspanelsTealLagoon.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV54GlasspanelsTealLagoon(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={54}
      archKey="glass_panels"
      archLabel="Frosted Glass Panels"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
